module.exports = __webpack_public_path__ + "static/media/payment_status_sponsored.e5eaca3d.svg";